module.exports = __webpack_public_path__ + "img/right-or-wrong.37529919.svg";